import { Button } from '@sweep-io/sweep-design';
import { APP_EXCHANGE_URL } from '../url-consts';

import { ArrowUpRight } from '@sweep-io/sweep-design/dist/icons/ArrowUpRight';

const AppExchangeButton = ({
  buttonSize,
  disabled,
}: {
  buttonSize?: 'small' | 'medium';
  disabled?: boolean;
}) => {
  const goToAppExchange = () => {
    window.open(APP_EXCHANGE_URL, '_blank');
  };
  return (
    <Button
      startIcon={ArrowUpRight}
      onClick={goToAppExchange}
      size={buttonSize ?? 'medium'}
      disabled={disabled}
    >
      Continue to AppExchange
    </Button>
  );
};

export default AppExchangeButton;
